import logo from './logo.svg';
import './App.css';
import { useEffect, useRef, useState } from 'react';
import Disinfect from './components/disinfect-none90/disinfect';
import SwiperChangeLayout from './components/swiperChangeLayout/swiperChangeLayout';
import Id from './components/id/id';
import DisinfectVideo from './components/disinfectVideo/disinfectVideo';
import Battery from './components/battery/battery';
import Waterproof from './components/waterproof/waterproof';
import Blue from './components/blue/blue';
import Voice from './components/voice/voice';
import DOMPurify from 'dompurify';
let language = document.querySelector('meta[name="language"]').content;
document.getElementById('root').setAttribute('lang', language);
document.getElementById('root').classList.add('no-cn');

let json = {
  text1: '观看视频',
  text2:
    '消费升级背景下，人们对生活品质的要求越来越高，消费需求变得更加品质化、个性化。追求高品质的健康生活方式，逐渐成为新趋势，<div class="mainText">智云关爱用户需求，善于发现探索，想到并做到，践行MAKE IT REAL，满足美好生活无限想象。 </div>',
  text3:
    '市面首款集<div class="mainText">语音娱乐、消毒、视听交互</div>于一体的消毒式防水音箱',
  text4: '兼具高音质通话和臭氧消毒功能，体验更全能。',
  text5: '仅有一掌大小，黑白双色可选，简约不简单。',
  text6:
    '手机已成为工作和生活必备品，其表面留存着<div class="mainText">大肠杆菌、金黄色葡萄球菌等多种肉眼看不见的有害菌</div>，这些细菌通过手机这个介质传播至生活角落，以各种方式进入人体内，从而引发疾病。如何在省时环保的前提下轻松完成手机表面消毒？智云以创新满足用户美好生活需求。',
  text7: '一键消毒，方便易上手',
  text8:
    '智云消毒音箱内置臭氧发生单元，通过高压激活臭氧片放电产生臭氧，使用时<div class="mainText">一键“Disinfect”激活释放臭氧。</div>',
  text9: '360°灭菌，一“净”到底',
  text10:
    '相比较于紫外线消毒、酒精消毒等消毒方式，臭氧气体可以<div class="mainText">直接转化为无害的氧气，更安全环保，而且能360°覆盖手机死角，高效灭菌无残留</div>，让手机消毒更彻底。',
  text11: '放浴室',
  text12: '放卧室',
  text13: '放办公室',
  text14: '都没问题',
  text15: '实现手机表面菌落消杀仅需',
  text16: '2分钟',
  text17: '杀菌率高达',
  text18: '0.99',
  text19: '* 数据来源于广东省微生物分析检测中心分析检测报告。',
  text20: '蓝牙5.3，信号强，延迟低',
  text21:
    '支持蓝牙5.3，能实现10米的远距离蓝牙信号传输；拥有更快的传输速度和低延时表现；支持记忆连接，手机等设备首次配对，后续开机自动连接。',
  text22:
    '* 蓝牙5.3兼容5.0和4.2；传输距离为空旷环境测试所得，实际使用环境可能有所差异。',
  text23: '10米远距离传输',
  text24: '抗干扰性强',
  text25: '传输速度快',
  text26: '低延时表现',
  text27: '出色性能，澎湃乐感',
  text28:
    '内置1个高频喇叭和2个中低频喇叭组成的音箱喇叭单元，带来音质饱满的听觉享受。',
  text29: '超长续航，快乐不断电',
  text30: '支持电量显示，内置2000mAh锂电池，超长续航，让玩乐更尽兴。',
  text31: '充满仅需',
  text32: '1H 40min',
  text33: '可连续播放音乐',
  text34: '8H 52min',
  text35: '防泼溅，边消毒，边娱乐',
  text36:
    '支持<div class="mainText">IPX4级防泼溅</div>，即使在泳池、浴室等周围潮湿环境中仍能正常使用；使用PET安全材质触控面板，内置松软海绵缓冲结构，可将手机放置其中进行消毒，消毒时仍可触控操作手机，也可操作接打/拒接电话，边消毒边享受视听娱乐。',
  text37:
    '* 盒内空间最大可放置iPhone 13 Pro Max手机；IPX4级防水不可将产品完全置于水中，仅代表泼溅不影响正常使用。',
  text38: '一物多用，尽情享乐',
  text39:
    '智云消毒音箱既是一款<div class="mainText">精致视听设备</div>，也是<div class="mainText">手机消毒器</div>，可用于游泳、沙滩、户外露营等场景娱乐视听播放。',
};
function App() {
  const [textData, setTextData] = useState(json);
  useEffect(() => {
    async function fetchData() {
      let response = await fetch(
        `https://www.zhiyun-tech.com/website/in18/xdyx/${language}.json`,
      );
      if (response.ok) {
        let json = await response.json();
        function formatText(text) {
          if (text.indexOf('{') < 0 && text.indexOf('_') < 0) {
            return text;
          } else if (text.indexOf('{') >= 0) {
            let rightBrackets = text.indexOf('{');
            let leftBrackets = text.indexOf('}') + 1;
            let oldText = text.slice(rightBrackets, leftBrackets);
            let newText = `<div class="mainText">${text.slice(
              rightBrackets + 1,
              leftBrackets - 1,
            )}</div>`;

            return formatText(text.replace(oldText, newText));
          } else if (text.indexOf('_') >= 0) {
            let brackets = text.indexOf('_');
            let oldText = text.slice(brackets, brackets + 1);
            let newText = `<br />`;
            return formatText(text.replace(oldText, newText));
          }
        }

        for (let item in json) {
          json[item] = formatText(json[item]);
        }
        // console.log(json);
        setTextData(json);
      } else {
        // console.log('HTTP-Error: ' + response.status);
      }
    }

    fetchData();
  }, []);
  return (
    <div className="App">
      <DisinfectVideo textData={textData} language={language} />
      {/* <Id /> */}
      <Disinfect textData={textData} />
      <Blue textData={textData}></Blue>
      <Voice textData={textData}></Voice>
      <Battery textData={textData}></Battery>
      <Waterproof textData={textData}></Waterproof>
      <SwiperChangeLayout
        style={{
          '--theme-color': '#FF6666',
        }}
        title={DOMPurify.sanitize(textData['text38'])}
        body={DOMPurify.sanitize(textData['text39'])}
        content={[
          {
            img: 'http://zhiyun-website-shenzhen.oss-cn-shenzhen.aliyuncs.com/detail/ozone-speaker/zhiyunlife-ozonespeaker-more-1.jpg',
          },
          {
            img: 'http://zhiyun-website-shenzhen.oss-cn-shenzhen.aliyuncs.com/detail/ozone-speaker/zhiyunlife-ozonespeaker-more-2.jpg',
          },
          {
            img: 'http://zhiyun-website-shenzhen.oss-cn-shenzhen.aliyuncs.com/detail/ozone-speaker/zhiyunlife-ozonespeaker-more-3.jpg',
          },
        ]}
      />
    </div>
  );
}

export default App;
